import { clsx } from 'clsx';
import React, { ReactNode } from 'react';

import { Button, Icon } from '@common/components';

export const DeprecatedStatePill = ({
  dropdown,
  color,
  fontSize,
  capitalized = false,
  children,
  className,
  ...other
}: {
  children?: ReactNode | undefined;
  fontSize?: string;
  // TODO(WORK-705): fix this color prop to use ColorsType
  color?: string;
  dropdown?: boolean;
  capitalized?: boolean;
  className?: string;
  icon?: React.ReactElement | null;
}) => (
  <>
    <Button
      {...other}
      size="sm"
      shape="round"
      iconRight={dropdown ? <Icon icon="caretDown" size="sm" /> : undefined}
      className={clsx(
        'wk-state-pill',
        `button-${color}`,
        'wk-state-pill--text-style',
        className,
        {
          'wk-state-pill--default-cursor': !dropdown,
        }
      )}
    >
      {children}
    </Button>
    <style jsx>{`
      :global(.wk-button.wk-state-pill.wk-state-pill--text-style) {
        font-size: ${fontSize};
        ${capitalized ? 'text-transform: capitalize;' : ''}
        padding: 0 12px;
      }

      :global(.wk-button.wk-state-pill.wk-state-pill--default-cursor) {
        cursor: default;
      }

      :global(.wk-button.wk-state-pill .wk-button__content + .wk-button__icon) {
        margin-left: 0.7em;
      }

      :global(.wk-button.wk-state-pill.wk-state-pill--text-style:active) {
        box-shadow: none;
      }

      :global(
        .wk-button.wk-state-pill.wk-state-pill--text-style:focus-visible
      ) {
        outline: none;
      }
    `}</style>
  </>
);
